<template lang="pug">
	.app--company-permissions
		Popup(v-if="companyPermissionPopup.visible", :popupVisible.sync="companyPermissionPopup.visible", :width="540", :height="240", :title="$tCaption('Manage permissions')")
			.flex-col.space
				.permission(v-for="permission in permissions")
					.flex-row.align-center.nowrap
						DxCheckBox.flex-1(:text="permission.name", :value="companyPermissionPopup.permission.Permissions.includes(permission.id)", @value-changed="v => togglePermission(companyPermissionPopup.permission, permission.id)")
						.flex-row.space.align-center.align-end.flex-1
							.font-small.grey.nowrap {{$tCaption('Active till:')}}
							DxDateBox(:value.sync="companyPermissionPopup.permission.ActiveTo" :showClearButton="true", stylingMode="filled", :width="220", type="datetime")
				Loader(v-if="companyPermissionPopup.loading", text="", :fullscreen="true")
			template(slot="actions-right")
				DxButton(:text="$tCaption('Cancel', '@actions')", @click="companyPermissionPopup.visible = false")
				DxButton(:text="$tCaption('Save', '@actions')", type="default", @click="savePermission")
</template>

<script>
	import _ from 'lodash';
	import { DELEGATION_PERMISSIONS } from 'app-core/constants';
	import Popup from 'app-core/Popup.vue';
	import DxCheckBox from 'devextreme-vue/check-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import DxButton from 'devextreme-vue/button';
	import Loader from 'app-core/Loader.vue';

	export default {
		translationCategory: 'company.CompanyProfile',
		name: 'company-permissions',
		components: { Popup, DxCheckBox, DxButton, Loader, DxDateBox },
		props: [],
		data() {
			return {
				allPermissions: [],
				permissions: DELEGATION_PERMISSIONS.toLocale('name', this),
				companyPermissionPopup: {
					visible: false,
					permission: null,
					sourcePermission: null,
					loading: false
				}
			}
		},
		computed: {
			activeTo: {
				get: function() {
					return this.companyPermissionPopup?.permission?.ActiveTo ? this.$moment(this.companyPermissionPopup?.permission?.ActiveTo).toDate() : null;
				},
				set: function(v) {
					this.companyPermissionPopup.permission.ActiveTo = v ? this.$Data.getUtcDate(v) : null;
				}
			}
		},
		mounted() {
			if (__DEBUG__)
				window.companyPermissions = this;
			this.loadCompanyPermissions();
		},
		methods: {
			async loadCompanyPermissions() {
				this.allPermissions = (await this.$Data.getExternalApi('CompanyDelegationPermission/GetPermissions', void 0, 9999))?.Results || [];
				this.$emit('loaded', true);
			},
			getCompanyPermission(companyId) {
				return this.allPermissions.find(f => f.AssignedTo?.Oid === companyId);
			},
			getCompanyPermissionText(companyId) {
				return (this.getCompanyPermission(companyId)?.Permissions || []).map(f => this.permissions[f]?.name).filter(f => f).join(', ');
			},
			manage(companyId) {
				this.companyPermissionPopup.visible = false;
				this.companyPermissionPopup.sourcePermission = this.getCompanyPermission(companyId);
				this.companyPermissionPopup.permission = _.cloneDeep(this.companyPermissionPopup.sourcePermission) || {
					AssignedTo: {
						Oid: companyId
					},
					Permissions: []
				};
				setImmediate(() => this.companyPermissionPopup.visible = true);
			},
			togglePermission(permission, permissionTypeCode) {
				this.$Data.toggleSelectedIdInArray(permissionTypeCode, permission.Permissions);
			},
			async savePermission() {
				this.companyPermissionPopup.loading = true;
				await this.$Data.postExternalApi('CompanyDelegationPermission/CreateUpdatePermission', this.companyPermissionPopup.permission)
					.then(r => {
						if (r?.Success !== false) {
							if (!this.companyPermissionPopup.permission?.Oid) {
								this.allPermissions.push(r?.Data);
							} else {
								_.assign(this.companyPermissionPopup.sourcePermission, r?.Data);
							}
						}
					})
					.finally(() => this.companyPermissionPopup.loading = false);
				this.companyPermissionPopup.visible = false;
			}
		}
	};
</script>
 